import { i18n } from '../i18n';

export enum ToastType {
  Empty = '',
  Tick = 'tick',
  Exclamation = 'exclamation'
}

export function getDefaultConfig() {
  return {
    className: '',
    type: ToastType.Tick,
    show: false,
    title: i18n('成功'),
    icon: 'tick',
    size: 140,
    isAutoHide: true,
  };
}
